export const MEMBER = {

  START_SET_OUTOFOFFICE: 'START_SET_OUTOFOFFICE',
  SETTING_OUTOFOFFICE: 'SETTING_OUTOFOFFICE',
  END_SET_OUTOFOFFICE: 'END_SET_OUTOFOFFICE',

  START_UPDATING_OUTOFOFFICE: 'START_UPDATING_OUTOFOFFICE',
  UPDATING_OUTOFOFFICE: 'UPDATING_OUTOFOFFICE',
  END_UPDATING_OUTOFOFFICE: 'END_UPDATING_OUTOFOFFICE',

  START_DELETING_OUTOFOFFICE: 'START_DELETING_OUTOFOFFICE',
  DELETING_OUTOFOFFICE: 'DELETING_OUTOFOFFICE',
  END_DELETING_OUTOFOFFICE: 'END_DELETING_OUTOFOFFICE',

  ERROR_START_DATE: 'The end date must be after the start date.',
  ERROR_DATE_RANGE: ' Date range cannot be greater than 1 month.',
  ERROR_PASSED_DATE: 'Date can not be a date that has passed.'
};
